import config from 'SRC/config/config.json'

export const projects = config.footer.projects.list.map((item, index) => ({
  id: index + 1,
  link: item.link,
  title: item.title
}))
